export default __webpack_public_path__ + "static/15-6b870e0e80d99173648cbcabc2ea7021.png";